import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { SEModule } from '@delon/abc/se';
import { ACLService } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { SharedModule } from '@shared';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormService } from 'src/app/core/util/form.service';
import { InputModule } from 'src/app/input/input.module';
import { GLAccountSelectComponent } from 'src/app/shared-feature/components/select/gl-account-select/gl-account-select.component';
import CurrenciesJson from 'src/assets/data/currencies.json';

@Component({
  selector: 'app-currency-modal',
  templateUrl: './currency-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputModule,
    SharedModule,
    GLAccountSelectComponent,
    ReactiveFormsModule,
    NzModalModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzButtonModule,
    NzIconModule,
    SEModule
  ]
})
export class CurrencyModalComponent {
  private fs = inject(FormService);
  private acl = inject(ACLService);
  private fb = inject(FormBuilder);
  private http = inject(_HttpClient);
  options = [...CurrenciesJson];
  nzFilterOption = (): boolean => true;
  visible = false;
  hasPermission = false;
  form = this.fb.group({
    id: [null, []],
    code: ['', [Validators.required]],
    sign: ['', [Validators.required, Validators.maxLength(5)]],
    name: ['', [Validators.required, Validators.maxLength(100)]],
    centFormat: ['', [Validators.maxLength(20)]],
    defaultSalesRate: [1, []],
    defaultPurchaseRate: [1, []],
    forexGainAccountId: [null, []],
    forexGainAccount: [null, []],
    forexLossAccountId: [null, []],
    forexLossAccount: [null, []],
    local: [false, []]
  });
  private callback = (res: any) => {};

  constructor() {
    this.form.controls.forexGainAccount.valueChanges.subscribe((value: any) => {
      if (value) {
        this.form.controls.forexGainAccountId.setValue(value.id);
      } else {
        this.form.controls.forexGainAccountId.setValue(null);
      }
    });

    this.form.controls.forexLossAccount.valueChanges.subscribe((value: any) => {
      if (value) {
        this.form.controls.forexLossAccountId.setValue(value.id);
      } else {
        this.form.controls.forexLossAccountId.setValue(null);
      }
    });
  }

  get canEdit() {
    return this.acl.canAbility('currency.update');
  }

  show(data: any, callback = (res: any) => {}) {
    this.hasPermission = data.id
      ? this.acl.canAbility('currency.update')
      : this.acl.canAbility('currency.create');
    if (this.hasPermission) this.form.enable();
    else this.form.disable();

    this.visible = false;
    this.options = [...CurrenciesJson];

    if (data.name && !data.code) {
      const currency = this.options.find(
        o => o.code === data.name || o.name === data.name
      );
      if (currency) {
        data.name = currency.name;
        data.code = currency.code;
      }
    }

    this.form.patchValue(data);
    this.callback = callback;
    this.visible = true;
  }

  handleOk() {
    if (!this.fs.validate(this.form).isValid) return;
    const body = { ...this.form.getRawValue() };
    if (
      (typeof body.id === 'number' && body.id === 0) ||
      (typeof body.id === 'string' && body.id === '0')
    ) {
      this.http.post('api/currencies/create', body).subscribe(res => {
        this.visible = false;
        this.callback(res);
      });
    } else {
      if (this.canEdit) {
        this.http.post('api/currencies/update', body).subscribe(res => {
          this.visible = false;
          this.callback(res);
        });
      } else this.visible = false;
    }
  }

  handleCancel() {
    this.visible = false;
  }

  search(val: string) {
    let options = [...CurrenciesJson];

    if (val) {
      val = val.toLowerCase();
      options = options.filter(
        o =>
          o.code.toLowerCase().includes(val) ||
          o.name.toLowerCase().includes(val)
      );
    }

    this.options = options;
  }
}
